import { useTranslation } from 'react-i18next';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function AboutPage() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main className="pt-24 md:pt-28">
        <div className="w-full px-4 md:px-8 lg:px-12 max-w-3xl mx-auto pb-20">
          <nav className="flex items-center gap-2 text-sm mb-8">
            <a href="/" className="text-warm-500 hover:text-brand-600 transition-colors">{t('breadcrumb.home')}</a>
            <i className="ri-arrow-right-s-line text-warm-400 text-xs" />
            <span className="text-warm-700">{t('nav.about')}</span>
          </nav>

          <h1 className="font-heading text-3xl md:text-4xl font-bold text-warm-900 mb-6">
            Sobre o CSSSpreadsheetBR
          </h1>

          <div className="prose max-w-none text-sm md:text-base text-warm-600 leading-relaxed space-y-4">
            <p>
              CSSSpreadsheetBR e um recurso independente criado para ajudar compradores a pesquisar, organizar e comparar produtos disponiveis atraves do agente de compras CSSBuy. Nosso objetivo e fornecer informacoes claras, organizadas e atualizadas para que voce tome decisoes de compra mais seguras.
            </p>

            <h2 className="font-heading text-xl md:text-2xl font-semibold text-warm-900 mt-8">Nossa Missao</h2>
            <p>
              Organizar recursos de forma pratica. O CSSBuy Spreadsheet reune links, categorias, guias e dicas em uma estrutura simples de navegar. Nao inventamos avaliacoes, precos ou cupons. O que fazemos e organizar informacoes e apontar para os recursos certos.
            </p>

            <h2 className="font-heading text-xl md:text-2xl font-semibold text-warm-900 mt-8">Independencia</h2>
            <p>
              Este site e um recurso independente e <strong>nao e afiliado nem endossado pela CSSBuy</strong>. Nao recebemos comissao por vendas. Nao garantimos precos. Nao inventamos cupons. Toda informacao aqui e fornecida para fins de pesquisa e organizacao.
            </p>

            <h2 className="font-heading text-xl md:text-2xl font-semibold text-warm-900 mt-8">Contato</h2>
            <p>
              Para dvidas, sugestoes ou atualizacoes, utilize os canais disponiveis no site principal. Este portal e mantido como um hub de informacao e nao como um servico de atendimento direto.
            </p>

            <div className="bg-brand-50 rounded-xl border border-brand-100 p-5 md:p-6 mt-8">
              <p className="text-sm text-warm-700 m-0">
                <strong>Aviso importante:</strong> {t('general.disclaimer')}
              </p>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}